enum HTTPErrorType {
    AUTH = 'auth',
    INPUT = 'input',
    MISSING = 'missing',
    FORBIDDEN = 'forbidden',
    UNPROCESSABLE = 'unprocessable',
    PAYMENT = 'payment',
    INTERNAL = 'internal',
}

export default HTTPErrorType;
